import gql from 'graphql-tag';

export const Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS = gql`
  query GetDealInfoFromExternalDms($input: GetDealInfoFromExternalDmsInput!) {
    getDealInfoFromExternalDms(input: $input) {
      businessName
      paymentType
      equipmentSubtotal
      salesTaxAmount
      totalFees
      netTrade
      invoiceTotal
      downPaymentAmount
      netFinanceAmount
      contact {
        firstName
        lastName
        email
        phone
        title
      }
      equipment {
        quantity
        year
        make
        model
        class
        vin
        stockNumber
        condition
        mileage
        description
        wholesaleCost
        retailPrice
      }
    }
  }
`;
